"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SchemaOptions {
    constructor() {
        this.options = {};
    }
    static getOptions(schemaOptions) {
        return schemaOptions.options;
    }
    static create() {
        return new SchemaOptions();
    }
    onBlur(callback) {
        this.add('onBlur', callback);
        return this;
    }
    onChange(callback) {
        this.add('onChange', callback);
        return this;
    }
    validateOnBlur(validate = true) {
        this.add('validateOnBlur', validate);
        return this;
    }
    validateOnChange(validate = true) {
        this.add('validateOnChange', validate);
        return this;
    }
    optional(params = true) {
        this.add('optional', params);
        return this;
    }
    required(params) {
        this.add('required', params);
        return this;
    }
    email(params) {
        this.add('email', params);
        return this;
    }
    max(params) {
        this.add('max', params);
        return this;
    }
    min(params) {
        this.add('min', params);
        return this;
    }
    pattern(params) {
        this.add('pattern', params);
        return this;
    }
    phone(params) {
        this.add('phone', params);
        return this;
    }
    document(params) {
        this.add('document', params);
        return this;
    }
    custom(params) {
        this.add('custom', params);
        return this;
    }
    add(option, value) {
        this.options = {
            ...this.options,
            [option]: value,
        };
    }
}
exports.default = SchemaOptions;
